import React from 'react';
import { CollectionHeaderStore } from '@reverbdotcom/commons/src/components/stores/collection_header_store';
import { get } from 'lodash';
import CollectionHeader from '@reverbdotcom/commons/src/components/stores/collection_header';
import PageTitle from '@reverbdotcom/commons/src/components/page_title';

interface Props {
  defaultTitle?: string;
}

interface State {
  collectionHeader: CollectionHeader;
}

export default class CollectionPageTitle extends React.Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      collectionHeader: CollectionHeaderStore.getState().collectionHeader,
    };

    this.onStoreUpdated = this.onStoreUpdated.bind(this);
  }

  componentDidMount() {
    CollectionHeaderStore.listen(this.onStoreUpdated);
  }

  componentWillUnmount() {
    CollectionHeaderStore.unlisten(this.onStoreUpdated);
  }

  onStoreUpdated() {
    const { collectionHeader } = CollectionHeaderStore.getState();
    this.setState({ collectionHeader });
  }

  title() {
    const collectionHeaderTitle = get(this.state, 'collectionHeader.title');
    return collectionHeaderTitle || this.props.defaultTitle;
  }

  render() {
    return <PageTitle title={this.title()} />;
  }
}
